import { IFormSegment } from 'components/SelectSegments/types'
import { GTAncillaryPlace, GTSegmentSuggestion } from 'gql/types.generated'

export const getSegmentOriginsOrDestinations = (
  segments: IFormSegment[],
  key: 'origin' | 'destination'
): GTAncillaryPlace[] => {
  return segments.reduce((result, current) => {
    const segment = current[key]
    const added = result.find(({ id }) => id === segment.id)
    if (!added) {
      result.push(segment as GTAncillaryPlace)
    }
    return result
  }, [] as GTAncillaryPlace[])
}

export const mapSegmentSuggestionsToFormSegments = (segmentSuggestions: GTSegmentSuggestion[]): IFormSegment[] => {
  return segmentSuggestions.map(
    (segment): IFormSegment => ({
      id: segment.id,
      origin: {
        id: segment.origin.id,
        name: segment.origin.name,
        code: segment.origin.code
      },
      destination: {
        id: segment.destination.id,
        name: segment.destination.name,
        code: segment.destination.code
      },
      cityOrigin: {
        id: segment.origin.cityID
      },
      cityDestination: {
        id: segment.destination.cityID
      }
    })
  )
}
